const instrumentList = require('../../DictInstrumentType.json')
const instrumentTypes = [ { "instr_type": "1", "instr_type_name": "燃气表" }, { "instr_type": "2", "instr_type_name": "电能表" }, { "instr_type": "3", "instr_type_name": "热能(量)表" }, { "instr_type": "4", "instr_type_name": "水表" }, { "instr_type": "5", "instr_type_name": "流量计" }, { "instr_type": "6", "instr_type_name": "压力表" }, { "instr_type": "7", "instr_type_name": "报警器(仪)" }, { "instr_type": "8", "instr_type_name": "衡器" }, { "instr_type": "9", "instr_type_name": "互感器" }, { "instr_type": "10", "instr_type_name": "试验机" }, { "instr_type": "11", "instr_type_name": "环保类" }, { "instr_type": "12", "instr_type_name": "其他" } ];
//器具数据
const instrumentAll = instrumentList as any;
//instr_type分组
const groupInstrumentByType = {} as any;
let groupInstrumentCountByType = {} as any;

//city_name分组
const groupInstrumentByCity = {} as any;
let groupInstrumentCountByCity = {} as any;
instrumentAll.sort((a: any,b: any) => a.instr_type - b.instr_type);
instrumentAll.forEach((instrument: any) => {
    //1.按照type进行分组
    {
        if(groupInstrumentByType[instrument.instr_type] == undefined){
            groupInstrumentByType[instrument.instr_type] = [];
            groupInstrumentCountByType[instrument.instr_type] = {name: instrument.instr_type_name, value: 0};
        }
        groupInstrumentCountByType[instrument.instr_type].value += 1;
        groupInstrumentByType[instrument.instr_type].push(instrument);
    }
    //2.按照市分组
    {
        if(groupInstrumentByCity[instrument.city_name] == undefined){
            groupInstrumentByCity[instrument.city_name] = [];
            groupInstrumentCountByCity[instrument.city_name] = {name: instrument.city_name, value: 0};
        }
        groupInstrumentCountByCity[instrument.city_name].value += 1;
        groupInstrumentByCity[instrument.city_name].push(instrument);
    }
});
groupInstrumentCountByCity = Object.values(groupInstrumentCountByCity);
groupInstrumentCountByType = Object.values(groupInstrumentCountByType);



export {instrumentTypes, instrumentAll, groupInstrumentByType, groupInstrumentByCity, groupInstrumentCountByCity, groupInstrumentCountByType}
